import React from "react";
import SuperAdminUserAnalysis from "./SuperAdminUserAnalysis";

function AdminUserAnalytics() {
    return (
        <>
            <SuperAdminUserAnalysis />
        </>
    );
}

export default AdminUserAnalytics;
